import { RouterProvider, createBrowserRouter, Navigate, Outlet, useLocation } from "react-router-dom";
import Login from "./pages/login/index";
import BasePage from "pages/base";
import ProtectedRoute from "components/ProtectedRoute";
import NotFoundPage from "pages/notFound";
import MaintenancePage from "pages/maintenance";
import EducatorBase from "pages/educatorBase";
import AIHelperGetStarted from "pages/base/AIHelperTool/AIHelperGetStarted";
import { useSelector } from "react-redux";
import AIHelperSkillsReview from "pages/base/AIHelperTool/AIHelperSkillsReview";
import AIHelperSubskillsReview from "pages/base/AIHelperTool/AIHelperSubskillsReview";
import AIHelperShareFeedback from "pages/base/AIHelperTool/AIHelperShareFeedback";

import store from "redux/store";
import educatorService from "services/educatorService";
import { setArtifactDetailsRedux } from "redux/slices/artifactDetails/artifactDetailsSlice";
import { setAssociatedSkillsRedux } from "redux/slices/associatedSkills/associatedSkillsSlice";

const RootLayout = () => {
  const location = useLocation();
  const isArtifactReviewRoute = location.pathname.startsWith("/artifact-review");
  
  return (
    <div className={`h-screen min-w-[968px] ${!isArtifactReviewRoute ? "overflow-hidden" : ""}`}>
      <Outlet />
    </div>
  );
};

const AppDisplay = () => {
  const { id, role } = useSelector((state: any) => state.account);

  const router = createBrowserRouter([
    {
      path: "/",
      element: <RootLayout />,
      errorElement: <NotFoundPage />,
      children: [
        {
          path: "/",
          element: <MaintenancePage />,
          // element: (
          //   <>
          //     {role == "ROLE_LEARNER" ? (
          //       <Navigate to="/base" replace />
          //     ) : (
          //       <Navigate to="/educator" replace />
          //     )}
          //   </>
          // ),
        },
        { path: "/login", element: <MaintenancePage /> },
        // { path: "/login", element: <Login /> },
        {
          path: "/base",
          element: <MaintenancePage />,
          // element: (
          //   <ProtectedRoute>
          //     {role === "ROLE_LEARNER" || role == "ROLE_EDUCATOR" ? <BasePage /> : <NotFoundPage />}
          //   </ProtectedRoute>
          // ),
        },
        {
          path: "/educator",
          element: <MaintenancePage />,
          // element: (
          //   <ProtectedRoute>
          //     {role === "ROLE_EDUCATOR" ? <EducatorBase /> : <NotFoundPage />}
          //   </ProtectedRoute>
          // ),
        },
        {
          path: "/artifact-review/*",
          element: <MaintenancePage />,
        },
        // {
        //   path: "/artifact-review",
        //   children: [        
        //     {
        //       path: "get-started",
        //       element: (
        //         <AIHelperGetStarted />
        //       ),
        //     },
        //     {
        //       path: "skills-review",
        //       element: (
        //         <AIHelperSkillsReview />
        //       ),
        //     },
        //     {
        //       path: "subskills-review",
        //       element: (
        //         <AIHelperSubskillsReview />
        //       ),
        //     },
        //     {
        //       path: "share-feedback",
        //       element: (
        //         <AIHelperShareFeedback />
        //       ),
        //     }
        //   ]
        // },
        {
          path: "*",
          element: <MaintenancePage />,
        },
      ]
    },
  ]);
  return (
    <RouterProvider router={router} />
  );
};

export default AppDisplay;
